import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=6b352a3a&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=6b352a3a&lang=scss&scoped=true&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b352a3a",
  null
  
)

export default component.exports